import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

function defaultTitleForSeverity(severity: string): string {
  switch (severity) {
    case 'success':
      return 'Success';
    case 'error':
      return 'Error';
    case 'warn':
    case 'warning':
      return 'Warning';
    case 'secondary':
    case 'contrast':
      return 'Notification';
    default:
      return 'Info';
  }
}

function normalizeToastMessage(message: ToastMessageOptions): ToastMessageOptions {
  const sev = message.severity ?? 'info';
  const summaryTrimmed = message.summary?.trim();
  const summary = summaryTrimmed || defaultTitleForSeverity(sev);
  return { ...message, severity: sev, summary };
}

/**
 * Ensures every toast has a visible title (summary). When summary is omitted,
 * it is derived from severity (success → "Success", error → "Error", etc.).
 */
@Injectable()
export class ZhylarToastMessageService extends MessageService {
  override add(message: ToastMessageOptions): void {
    if (!message) {
      return;
    }
    super.add(normalizeToastMessage(message));
  }

  override addAll(messages: ToastMessageOptions[]): void {
    if (!messages?.length) {
      return;
    }
    super.addAll(messages.map(m => normalizeToastMessage(m)));
  }
}
